// Funktion zum Starten der Konfetti-Animation über einem bestimmten HTML-Container.
// Sie erstellt ein Canvas-Element, zeichnet Konfetti-Stücke und animiert deren Fall.
export function launchConfettiOverBox(canvas) {
  // Überprüft, ob das Canvas-Element existiert.
  if (!canvas) {
    console.error("Confetti canvas element is null.");
    return;
  }

  const ctx = canvas.getContext("2d");
  const container = canvas.parentNode; // Der übergeordnete Knoten ist der Quiz-Container.
  // Überprüft, ob der übergeordnete Container existiert.
  if (!container) {
    console.error("Confetti canvas has no parent container.");
    return;
  }

  const width = container.clientWidth; // Breite des Containers.
  const height = container.offsetHeight; // Höhe des Containers.
  canvas.width = width;
  canvas.height = height;
  canvas.style.display = "block";
  canvas.style.position = "absolute"; // Absolut positioniert innerhalb des Quiz-Containers.
  canvas.style.top = "0";
  canvas.style.left = "0";
  canvas.style.pointerEvents = "none"; // Lässt Klicks auf darunterliegende Elemente zu.
  canvas.style.zIndex = "1000"; // Stellt sicher, dass das Konfetti über anderen Elementen liegt.

  // Initialisiert 100 Konfetti-Stücke mit zufälligen Startpositionen, Größen, Farben und Bewegungen.
  const pieces = Array.from({ length: 100 }, () => ({
    x: Math.random() * width, // Zufällige X-Startposition.
    y: height - 10 + Math.random() * 10, // Startet knapp über dem unteren Rand.
    r: Math.random() * 6 + 2, // Radius des Konfetti-Stücks.
    color: ["#fad7d2", "#fce8dc", "#d6a77a", "#ebf2f7", "#8ecae6", "#ffb703", "#ff8fa3", "#caffbf"][Math.floor(Math.random() * 8)], // Zufällige Farbe aus definierter Palette.
    speed: Math.random() * 0.5 + 0.3, // Zufällige Fallgeschwindigkeit.
    drift: Math.random() * 2 - 1, // Zufällige seitliche Drift.
    alpha: 1 // Anfangs-Deckkraft.
  }));

  let frame = 0; // Korrekte Deklaration der Frame-Variable.
  const duration = 120; // Dauer der Animation in Frames (ca. 2 Sekunden bei 60fps).

  // Die Haupt-Zeichenfunktion, die in jedem Animationsframe aufgerufen wird.
  function draw() {
    ctx.clearRect(0, 0, width, height); // Löscht den Canvas-Inhalt des vorherigen Frames.
    pieces.forEach(p => {
      const fadeStart = duration * 0.6; // Zeitpunkt in Frames, ab dem das Konfetti ausblendet.
      if (frame > fadeStart) {
        // Reduziert die Deckkraft, um ein Ausblenden zu simulieren.
        p.alpha = Math.max(0, 1 - (frame - fadeStart) / (duration - fadeStart));
      }

      ctx.beginPath();
      // Zeichnet einen Kreis für jedes Konfetti-Stück.
      ctx.arc(p.x + frame * p.drift, p.y - frame * p.speed, p.r, 0, Math.PI * 2);
      ctx.fillStyle = p.color;
      ctx.globalAlpha = p.alpha; // Wendet die aktuelle Deckkraft an.
      ctx.fill();
      ctx.globalAlpha = 1; // Setzt die globale Deckkraft für nachfolgende Zeichnungen zurück.
    });

    frame++; // 'frame' inkrementieren.
    if (frame < duration) {
      requestAnimationFrame(draw); // Fordert den nächsten Animationsframe an.
    } else {
      canvas.style.display = "none"; // Blendet das Canvas aus, wenn die Animation beendet ist.
    }
  }

  draw(); // Startet die Konfetti-Animation.
}